import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { bdiOptions } from '@/module/Nomen/Bdi/model/BdiModel';

import { AsyncMultiSelectControl, AsyncSelectControlProps } from '@/core/components';

type BdiMultiSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function BdiMultiSelectControl<T extends FieldValues>(props: BdiMultiSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(bdiOptions.getAll());

  return (
    <AsyncMultiSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
